import { Anchor, Tooltip } from '@mantine/core';
import { ExternalLink as LinkIcon } from 'lucide-react';
import { FC } from 'react';

import { cn } from '@/utils/styleUtils.ts';

interface Props {
    href?: string;
    onClick?: () => void;
    text: string;
    tooltipLabel?: string;
    classNames?: {
        anchor?: string;
        icon?: string;
        text?: string;
    };
}

const ExternalLink: FC<Props> = ({ href, onClick, text, tooltipLabel, classNames }) => {
    return (
        <Tooltip label={tooltipLabel ?? text} disabled={!tooltipLabel && !text}>
            <Anchor
                href={href}
                onClick={onClick}
                target="_blank"
                aria-label={text ?? tooltipLabel}
                rel="noreferrer noopener"
                className={cn('flex items-center gap-1', classNames?.anchor)}
            >
                {text && <span className={cn('max-w-[450px] truncate text-black', classNames?.text)}>{text}</span>}
                <LinkIcon aria-label={text ?? tooltipLabel} className={cn('size-4', classNames?.icon)} />
            </Anchor>
        </Tooltip>
    );
};

export default ExternalLink;
